// ===== 后端API地址配置 =====
// 如需修改后端地址，只改这一行即可
export const API_BASE_URL = "https://13630.cc";

export interface Partner {
  id: number;
  name: string;
  handle: string;
  tg_url: string;
  avatar_url: string;
  dept: string;
  sort: number;
  status: number;
}

export interface Guarantee {
  id: number;
  guarantee_id: string;
  name: string;
  remark: string;
  status: number;
  created_at: string;
}

export interface ActivityItem {
  id: string;
  title: string;
  title_url?: string;
  lines: string[];
}

export interface ActivitySettings {
  contact: string;
  contact_url: string;
  footer_note: string;
  items: ActivityItem[];
  redirect_url?: string;
  right_image?: string;
}

export const mockPartners: Partner[] = [
  { id: 1, name: "迪猫", handle: "@hx_zs888", tg_url: "https://t.me/hx_zs888", avatar_url: "", dept: "promotion", sort: 1, status: 1 },
  { id: 2, name: "太阳", handle: "@hexing95277", tg_url: "https://t.me/hexing95277", avatar_url: "", dept: "promotion", sort: 2, status: 1 },
  { id: 3, name: "河马", handle: "@hm777321", tg_url: "https://t.me/hm777321", avatar_url: "", dept: "promotion", sort: 3, status: 1 },
  { id: 4, name: "小熊", handle: "@xiiiong", tg_url: "https://t.me/xiiiong", avatar_url: "", dept: "third", sort: 1, status: 1 },
  { id: 5, name: "荷花", handle: "@newhexing", tg_url: "https://t.me/newhexing", avatar_url: "", dept: "third", sort: 2, status: 1 },
  { id: 6, name: "合兴", handle: "@HX_88888", tg_url: "https://t.me/HX_88888", avatar_url: "", dept: "third", sort: 3, status: 1 },
];

export const mockGuarantees: Guarantee[] = [
  { id: 1, guarantee_id: "HX20240001", name: "测试担保", remark: "正式担保记录", status: 1, created_at: "2024-01-15 10:30:00" },
  { id: 2, guarantee_id: "HX20240002", name: "合作担保", remark: "", status: 1, created_at: "2024-01-20 14:22:00" },
  { id: 3, guarantee_id: "HX20240003", name: "三方担保", remark: "三方合作项目", status: 1, created_at: "2024-02-01 09:15:00" },
  { id: 4, guarantee_id: "HX20240004", name: "已失效", remark: "已过期", status: 0, created_at: "2024-02-10 16:45:00" },
];

export const defaultActivitySettings: ActivitySettings = {
  contact: "@hx_zs888",
  contact_url: "https://t.me/hx_zs888",
  footer_note: "其他投流方式的合作伙伴均会出台相对应的活动及奖励,欢迎业界顶尖合作伙伴前来合作。",
  redirect_url: "",
  right_image: "https://www.au2p0rz.vip/assets/activity-person-pc-CwU3lVY0.webp",
  items: [
    {
      id: "act1",
      title: "【活动一】每月发量:",
      lines: [
        "提供> 500万量的机房,奖励:1888$",
        "提供> 1000万量的机房,奖励:2888$",
        "提供> 1500万量的机房,奖励:5888$",
        "提供> 3000万量的机房,奖励:8888$",
        "各个渠道的品质制定分类以(量+价格+成本)后计算奖励,联系663客服登记、查询",
      ],
    },
    {
      id: "act2",
      title: "【活动二】优质机房搭建深度合作",
      lines: [
        "第一名奖励:3888$",
        "第二名奖励:2888$",
        "第三名奖励:1888$",
      ],
    },
    {
      id: "act3",
      title: "【活动三】引荐资源红包",
      lines: [
        "1,合作伙伴推荐靠谱机房",
        "2,深度合作机房,TG签名添加:【合盈】优秀合作伙伴,指定官网:663.com",
        "3,频道发布信息成功引荐真实机房",
      ],
    },
    {
      id: "act4",
      title: "【活动四】资源扶持计划",
      lines: [
        "给予任何想要与合盈一起攀登顶峰的伙伴帮助及支持,符合以下规则",
        "1,符合以上条件均可联系合盈工作人员申领,经审核通过直接发放",
        "2,每一位机房通道,仅能享受一次奖励若有违规者,将不享受此优惠",
        "3,任何违反活动规则可能被取消资格,连带引荐人的相关利益",
        "4,本公司保留随时以任何理由结束或修改任何活动的权利,恕不另行通知",
      ],
    },
  ],
};

// 活动设置缓存key
const ACTIVITY_CACHE_KEY = "hx_activity_settings_cache";

// 从API获取活动设置（优先数据库，失败降级缓存/默认值）
export async function fetchActivitySettings(): Promise<ActivitySettings> {
  try {
    const res = await fetch(`${API_BASE_URL}/api/settings/activity`, {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
    });
    const data = await res.json();
    if (data.code === 200 && data.data) {
      const result: ActivitySettings = {
        contact: data.data.contact ?? defaultActivitySettings.contact,
        contact_url: data.data.contact_url ?? defaultActivitySettings.contact_url,
        footer_note: data.data.footer_note ?? defaultActivitySettings.footer_note,
        redirect_url: data.data.redirect_url ?? defaultActivitySettings.redirect_url,
        right_image: data.data.right_image ?? defaultActivitySettings.right_image,
        // items 直接用数据库的，不合并默认值（避免数据库清空后仍显示默认活动）
        items: Array.isArray(data.data.items) ? data.data.items : defaultActivitySettings.items,
      };
      localStorage.setItem(ACTIVITY_CACHE_KEY, JSON.stringify(result));
      return result;
    }
    throw new Error('API返回错误');
  } catch {
    // API失败，读缓存或默认值
    const cached = localStorage.getItem(ACTIVITY_CACHE_KEY);
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        return {
          contact: parsed.contact ?? defaultActivitySettings.contact,
          contact_url: parsed.contact_url ?? defaultActivitySettings.contact_url,
          footer_note: parsed.footer_note ?? defaultActivitySettings.footer_note,
          redirect_url: parsed.redirect_url ?? defaultActivitySettings.redirect_url,
          right_image: parsed.right_image ?? defaultActivitySettings.right_image,
          items: Array.isArray(parsed.items) ? parsed.items : defaultActivitySettings.items,
        };
      } catch {
        return defaultActivitySettings;
      }
    }
    return defaultActivitySettings;
  }
}

// 获取活动设置（同步，返回缓存数据，用于初始渲染）
export function getActivitySettings(): ActivitySettings {
  const cached = localStorage.getItem(ACTIVITY_CACHE_KEY);
  if (cached) {
    try {
      const parsed = JSON.parse(cached);
      return {
        contact: parsed.contact ?? defaultActivitySettings.contact,
        contact_url: parsed.contact_url ?? defaultActivitySettings.contact_url,
        footer_note: parsed.footer_note ?? defaultActivitySettings.footer_note,
        redirect_url: parsed.redirect_url ?? defaultActivitySettings.redirect_url,
        right_image: parsed.right_image ?? defaultActivitySettings.right_image,
        items: Array.isArray(parsed.items) ? parsed.items : defaultActivitySettings.items,
      };
    } catch {
      return defaultActivitySettings;
    }
  }
  return defaultActivitySettings;
}

// 保存活动设置到API
export async function saveActivitySettingsAPI(settings: ActivitySettings, token: string): Promise<boolean> {
  try {
    const res = await fetch(`${API_BASE_URL}/admin/settings/activity`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(settings),
    });
    const data = await res.json();
    if (data.code === 200) {
      // 成功后更新本地缓存
      localStorage.setItem(ACTIVITY_CACHE_KEY, JSON.stringify(settings));
      return true;
    }
    return false;
  } catch {
    // 网络失败，保存到本地缓存
    localStorage.setItem(ACTIVITY_CACHE_KEY, JSON.stringify(settings));
    return false;
  }
}

export interface SiteSettings {
  merchant_name: string;
  merchant_handle: string;
  merchant_tg_url: string;
  complaint_name: string;
  complaint_handle: string;
  complaint_tg_url: string;
  site_name: string;
  footer_tg: string;
  hero_images: string[];
  // 关于合盈文字
  about_title: string;
  about_text: string;
  // 服务体系
  service_title: string;
  service_desc: string;
  service_image: string;
  // 核心价值观图片
  values_image: string;
  // 寻求代投资源图片
  collab_image: string;
  // Logo图片（顶部导航 + 底部）
  logo_image: string;
  // 底部版权文字
  footer_copyright: string;
}

export const defaultSiteSettings: SiteSettings = {
  merchant_name: "迪猫",
  merchant_handle: "@hx_zs888",
  merchant_tg_url: "https://t.me/hx_zs888",
  complaint_name: "迪猫",
  complaint_handle: "@hx_zs888",
  complaint_tg_url: "https://t.me/hx_zs888",
  site_name: "合盈 663.com",
  footer_tg: "@hx_zs888",
  hero_images: [
    "https://readdy.ai/api/search-image?query=Chinese%20corporate%20banner%20background%2C%20deep%20red%20and%20gold%20gradient%2C%20abstract%20geometric%20patterns%2C%20luxury%20business%20style%2C%20dark%20red%20background%20with%20golden%20lines%2C%20professional%20corporate%20identity%2C%20elegant%20and%20modern%2C%20no%20text%2C%20wide%20banner%20format&width=1200&height=300&seq=hero-hx-001&orientation=landscape"
  ],
  about_title: "关于合盈",
  about_text: "合盈集团自成立以来,秉承\"合于信,盈于行\"的理念,我们始终坚信,信任是合作关系的基石,卓越的执行力则是可持续发展的引擎。在过去的发展历程中,我们始终坚守\"诚信为本、合作共赢、追求卓越\"三大核心价值观,将其作为企业立身与发展的根本。合盈的使命:持续创造价值,驱动行业变革。合盈的愿景:铸就百年品牌,成为您\"百年大业\"最信赖的合作伙伴。",
  service_title: "一对一专员",
  service_desc: "除指派专员进行日常业务对接外,另委派项目负责人履行监督职能。该负责人统筹项目全局,具备快速决策与纠偏响应能力,旨在最大限度降低沟通成本,保障项目高质量交付,共创双赢局面。",
  service_image: "https://www.au2p0rz.vip/assets/service-person-pc-BzF-gzlj.webp",
  values_image: "https://www.au2p0rz.vip/assets/values-pc-DmGeFkyC.webp",
  collab_image: "https://www.au2p0rz.vip/assets/collab-banner-pc-CKsuST2e.webp",
  logo_image: "https://www.au2p0rz.vip/assets/logo-hx-BTyYeU-t.webp",
  footer_copyright: "合盈集团 © 2024  |  663.com",
};

// 站点设置缓存key
const SITE_SETTINGS_CACHE_KEY = "hx_site_settings_cache";

// 从API获取站点设置
export async function fetchSiteSettings(): Promise<SiteSettings> {
  try {
    const res = await fetch(`${API_BASE_URL}/api/settings/site`, {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
    });
    const data = await res.json();
    if (data.code === 200 && data.data) {
      // 合并默认值，防止数据库缺字段时前台显示空白
      const merged: SiteSettings = { ...defaultSiteSettings, ...data.data };
      localStorage.setItem(SITE_SETTINGS_CACHE_KEY, JSON.stringify(merged));
      return merged;
    }
    throw new Error('API返回错误');
  } catch {
    // API失败，读缓存或默认值
    const cached = localStorage.getItem(SITE_SETTINGS_CACHE_KEY);
    return cached ? { ...defaultSiteSettings, ...JSON.parse(cached) } : defaultSiteSettings;
  }
}

// 获取站点设置（同步，返回缓存数据）
export function getSiteSettings(): SiteSettings {
  const cached = localStorage.getItem(SITE_SETTINGS_CACHE_KEY);
  return cached ? { ...defaultSiteSettings, ...JSON.parse(cached) } : defaultSiteSettings;
}

// 保存站点设置到API
export async function saveSiteSettingsAPI(settings: SiteSettings, token: string): Promise<boolean> {
  try {
    const res = await fetch(`${API_BASE_URL}/admin/settings/site`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(settings),
    });
    const data = await res.json();
    if (data.code === 200) {
      // 成功后更新本地缓存
      localStorage.setItem(SITE_SETTINGS_CACHE_KEY, JSON.stringify(settings));
      return true;
    }
    return false;
  } catch {
    // 网络失败，保存到本地缓存
    localStorage.setItem(SITE_SETTINGS_CACHE_KEY, JSON.stringify(settings));
    return false;
  }
}

// ===== 商务人员本地缓存 =====
const PARTNERS_CACHE_KEY = "hx_partners_cache";

export function getCachedPartners(): Partner[] | null {
  try {
    const saved = localStorage.getItem(PARTNERS_CACHE_KEY);
    if (!saved) return null;
    const parsed = JSON.parse(saved);
    if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    return null;
  } catch {
    return null;
  }
}

export function setCachedPartners(partners: Partner[]): void {
  try {
    localStorage.setItem(PARTNERS_CACHE_KEY, JSON.stringify(partners));
  } catch {
    // ignore
  }
}

export function clearPartnersCache(): void {
  localStorage.removeItem(PARTNERS_CACHE_KEY);
}

// ===== 担保记录本地缓存 =====
const GUARANTEES_CACHE_KEY = "hx_guarantees_cache";

export function getCachedGuarantees(): Guarantee[] | null {
  try {
    const saved = localStorage.getItem(GUARANTEES_CACHE_KEY);
    if (!saved) return null;
    const parsed = JSON.parse(saved);
    if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    return null;
  } catch {
    return null;
  }
}

export function setCachedGuarantees(guarantees: Guarantee[]): void {
  try {
    localStorage.setItem(GUARANTEES_CACHE_KEY, JSON.stringify(guarantees));
  } catch {
    // ignore
  }
}

/**
 * 获取所有认证ID列表（担保记录缓存 + 商务人员TG账号缓存）
 * 优先读缓存，没有缓存用 mock 数据
 */
export function getAllVerifiedIds(): Array<{ id: string; name: string; remark: string; status: number }> {
  // 担保记录：优先读缓存，没有用 mock
  const guarantees: Guarantee[] = getCachedGuarantees() ?? mockGuarantees;

  // 商务人员：优先读缓存（key 是 hx_partners_cache），没有用 mock
  const partners: Partner[] = getCachedPartners() ?? mockPartners;

  const result: Array<{ id: string; name: string; remark: string; status: number }> = [];

  for (const g of guarantees) {
    result.push({ id: g.guarantee_id, name: g.name, remark: g.remark, status: g.status });
  }

  for (const p of partners) {
    if (p.handle) {
      const exists = result.some(r => r.id.toLowerCase() === p.handle.toLowerCase());
      if (!exists) {
        result.push({ id: p.handle, name: p.name, remark: `${p.name} - 官方认证商务人员`, status: p.status });
      }
    }
  }

  return result;
}
